import { Injectable } from '@angular/core';
import { Apollo, MutationResult } from 'apollo-angular';
import { Observable, map } from 'rxjs';

import {
  ISignBuyListResult,
  IProcessBuyListInput,
  IProcessBuyListResult,
  IAllBuyListFromOrganizationInput,
  IAllBuyListFromOrganizationResult,
  ISharePropertyWithBuyListsInput,
  ISharePropertyWithBuyListsResult,
  IIsBuyListCreationAllowedResult,
} from '@shared/models/buyers-list';
import {
  SIGN_BUY_LIST,
  ALL_BUY_LIST_FROM_ORGANIZATION,
  SHARE_PROPERTY_WITH_BUY_LISTS,
  IS_BUY_LIST_CREATION_ALLOWED,
} from '@graphql/queries/buyers-list.queries';
import { PROCESS_BUY_LIST } from '@graphql/mutations/buyers-list.mutations';

@Injectable({
  providedIn: 'root',
})
export class BuyersListService {
  constructor(private apollo: Apollo) {}

  signBuyList(dataType: 'CSV'): Observable<ISignBuyListResult> {
    return this.apollo
      .query({
        query: SIGN_BUY_LIST,
        variables: { dataType },
      })
      .pipe(map((result) => result.data));
  }

  processBuyList(
    input: IProcessBuyListInput
  ): Observable<MutationResult<IProcessBuyListResult>> {
    return this.apollo
      .mutate({
        mutation: PROCESS_BUY_LIST,
        variables: input,
        errorPolicy: 'all',
      })
      .pipe(map((result) => result));
  }

  allBuyListFromOrganization(
    input: IAllBuyListFromOrganizationInput
  ): Observable<IAllBuyListFromOrganizationResult> {
    return this.apollo
      .query({
        query: ALL_BUY_LIST_FROM_ORGANIZATION,
        variables: input,
      })
      .pipe(map((result) => result.data));
  }

  sharePropertyWithBuyLists(
    input: ISharePropertyWithBuyListsInput
  ): Observable<MutationResult<ISharePropertyWithBuyListsResult>> {
    return this.apollo
      .query({
        query: SHARE_PROPERTY_WITH_BUY_LISTS,
        variables: input,
        errorPolicy: 'all',
      })
      .pipe(map((result) => result));
  }

  isBuyListCreationAllowed(): Observable<IIsBuyListCreationAllowedResult> {
    return this.apollo
      .query({
        query: IS_BUY_LIST_CREATION_ALLOWED,
      })
      .pipe(map((result) => result.data));
  }
}
